module.exports = __webpack_public_path__ + "image/TM_2.png";